import { icons } from "@/components"
import { UserSelect } from "@/components/forms"
import type { TQuestionProps } from "./types"

export function QuestionUser({ value, setValue, field }: TQuestionProps) {
  const { onBlur, onFocus, error } = field || {}
  return (
    <UserSelect
      size="lg"
      error={error}
      onBlur={onBlur}
      onFocus={onFocus}
      leftSection={<icons.User />}
      value={value ? value.toString() : null}
      onChange={(value) => setValue(value ? parseInt(value, 10) : null)}
    />
  )
}
